const SColors = {
    Black: '#222222',
    BlackLabelFont: '#202020',
    BlackLabelFontAlpha: '#202020de',
    White: '#FFFFFF',
    hoverColor: '#CDC7FF',
    backgroundColor: '#E3DFFF',
    RedError: '#FE1149',
    Purple50: '#F0EEFF',
    Gray400: '#6C6C6C',
    Gray350: '#878787',
    Gray300: '#BBBCBC',
    Gray200: '#DDDEDE',
    Gray150: '#EBEBEC',
    Gray125: '#F2F2F2',
    Gray100: '#F7F8F8',
    Gray50: '#F9F9F9',
    GrayLabelPlaceholder: '#7F7F7F',
    GrayUnselectedRadioOutline: '#E3E7EF',
    GrayUnselectedCheckboxBackground: '#F2F2F2',
    GrayUnselectedCheckboxOutline: '#CCCCCC',
    Blue350: '#009EDA',
    Blue300: '#5ABFE5',
    Blue250: '#7AC5FB',
    Blue200: '#D9F4FF',
    Orange350: '#F05404',
    Orange300: '#FADED0',
    Orange200: '#eda495',
    DarkGreen: '#418629',
    Yellow: '#FFC83A',
    lightGray: '#C4C4C4',
    languageSwitcherLongBeachDisabled: 'black',
    lbGray: `rgba(32, 32, 32, 0.87)`,
    lbBlue: '#236092',
}

export default SColors
